import { createSelector } from 'reselect'

const getStudentViewData = state => state.student

const studentViewSelector = createSelector(
	[ getStudentViewData ],
	student => student
)

export default studentViewSelector
